import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { GridModule } from '@df/ui/atomic/atom/grid/grid.module';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent } from '@icms/core/content';
import { CMS_COMPONENT_CMS_CONFIG } from './cms-component-row.config';
import { NCmsComponentRow } from './cms-component-row.interface';

@Component({
    selector: 'cms-component-row',
    templateUrl: './cms-component-row.component.html',
    standalone: true,
    imports: [GridModule, ICmsClientModule, NgClass],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<CmsComponentRowComponent>(CMS_COMPONENT_CMS_CONFIG)
export class CmsComponentRowComponent extends UiComponent implements NICmsContentComponent.IComponent {
    protected override asyncCd = false;

    @ICmsContent({
        type: 'component'
    })
    component!: NCmsComponentRow.IData;

    protected trackByFn(item: NCmsComponentRow.IColumn) {
        return item;
    }
}
